import type { NonEmptyArray, TranslationRegistry } from '@festina-life/core'

import type { CommandMetadata } from '../../../components/commandActions/commandPalette/types'

export const getActionMetadata = <TCategory extends string>(
  actionMetadata: Record<
    string,
    CommandMetadata<NonEmptyArray<TCategory>, keyof TranslationRegistry>
  >,
  actionKey: string,
) => {
  if (actionKey in actionMetadata) {
    return actionMetadata[actionKey]
  }
  throw new Error(`No action metadata defined for action key: ${actionKey}`)
}
